<template>
  <div class="main-loader">
    <div class="circle"></div>
    <div class="circle"></div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

.main-loader {
  height: 40px;
  transform-origin: bottom center;
  animation: rotate 1s linear infinite;
}

.circle {
  display: inline-block;
  background-color: $mainGreen;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  transform: scale(0);
  animation: grow 1s linear infinite;
  margin: -0px;
}

.circle:nth-child(2) {
  background-color: $mainBlue;
  animation-delay: 0.25s;
}

@keyframes rotate {
  to {
    transform: rotate(360deg);
  }
}

@keyframes grow {
  50% {
    transform: scale(1);
  }
}

</style>